/**
 * Home — the landing page. Moved out of App.js in PERF-Phase-1 so all
 * 12 section imports + homeData.js + webpManifest.js leave the main
 * chunk. Every other route is already lazy; Home now follows the same
 * pattern (lazy() in App.js). The hero's <link rel=preload> lives in
 * server.js's per-route injector, so LCP does not regress from the split.
 */
import Header from "../components/sections/Header";
import Hero from "../components/sections/Hero";
import WhyAnderson from "../components/sections/WhyAnderson";
import BursarySupport from "../components/sections/BursarySupport";
import LegacyTimeline from "../components/sections/LegacyTimeline";
import Testimonials from "../components/sections/Testimonials";
import WhyAndersonText from "../components/sections/WhyAndersonText";
import FinancialAid from "../components/sections/FinancialAid";
import FAQ from "../components/sections/FAQ";
import BlogPosts from "../components/sections/BlogPosts";
import DiscoverVideo from "../components/sections/DiscoverVideo";
import Accreditations from "../components/sections/Accreditations";
import CtaFuture from "../components/sections/CtaFuture";
import Footer from "../components/sections/Footer";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <WhyAnderson />
        <BursarySupport />
        <LegacyTimeline />
        <Testimonials />
        <WhyAndersonText />
        <FinancialAid />
        <FAQ />
        <BlogPosts />
        <DiscoverVideo />
        <Accreditations />
        <CtaFuture />
      </main>
      <Footer />
    </div>
  );
}
